module.exports = {
	"fr": {
		"hqm": {
			"support-button": "Obtenir de l'aide",
			"support-page": {
				"create-ticket": {
					"title": "Obtenir de l'aide",
					"instructions": "Faites une demande ci-dessous et nous vous contacterons.",
					"fields": {
						"mid": {
							"label": "Sélectionner la boutique",
							"validation": "Boutique requise"
						},
						"topic": {
							"question": "Quel est le sujet de votre question ?",
							"label": "Choisir un sujet",
							"validation": "Sujet requis",
							"options": {
								"orders": "Commandes",
								"settlements": "Règlements",
								"agreements": "Accords",
								"technical_issues": "Problèmes techniques",
								"others": "Autres"
							}
						},
						"subject": {
							"label": "Sujet",
							"validation": "Sujet requis"
						},
						"description": {
							"label": "Message",
							"validation": "Description requise"
						},
						"attachment": {
							"label": "Ajoutes des pièces jointes",
							"button": "Charger",
							"info": "Ajoutez des captures d'écran pour nous aider à résoudre le problème plus rapidement.",
							"supportedFileTypes": "Types de fichiers pris en charge : .png, .jpg, .pdf",
							"error": "La taille de tous les fichiers ne doit pas dépasser 15 Mb"
						}
					},
					"submit": "Faire une demande",
					"service-unavailable-error": "Oups ! Une erreur s'est produite, réessayez dans quelques minutes. Si le problème persiste, {link} pour obtenir de l'aide.",
					"contact-page-link": "contactez-nous"
				},
				"view-ticket": {
					"title": "C'est fait !",
					"details": "Nous avons bien reçu votre demande et nous vous répondrons dans les plus brefs délais. Voici vos informations :",
					"ticket": "Demande n° {ticketId}",
					"email": "Adresse e-mail : {email}",
					"status": "Vous pouvez suivre le statut sur notre d'assistance.",
					"track": "Suivre le statut"
				}
			},
			"popup": {
				"yes": "Oui",
				"no": "Non",
				"somethingElse": "J'ai besoin d'aide avec quelque chose d'autre"
			},
			"header": {
				"homeLink": "Réinitialiser"
			},
			"home": {
				"greeting": "Bonjour {givenName} ! En quoi pouvons-nous vous aider ?",
				"topics": "En quoi pouvons-nous vous aider ?"
			},
			"topics": {
				"expandButton": "Plus"
			},
			"moreHelp": {
				"relatedArticlesParagraph": "Nous sommes désolés que cela ne vous ait pas aidé(e). Certains de ces articles vous seront peut-être utiles.",
				"stillQuestionsTitle": "D'autres questions ?",
				"stillQuestionsParagraph": "Vous pouvez aussi nous contacter directement.",
				"contactButton": "Contactez-nous"
			},
			"feedback": {
				"title": "Cela vous a-t-il aidé(e) ?",
				"optionYes": "Oui, cela m'a aidé(e)",
				"optionNo": "Non, j'ai toujours besoin d'aide",
				"positiveFeedback": "Merci pour votre retour positif, cela nous aide beaucoup à vous proposer des articles plus pertinents à l'avenir."
			},
			"freeTextFeedback": {
				"title": "Aidez-nous à nous améliorer",
				"placeholder": "Pourquoi n'avez-vous pas trouvé ce contenu utile ?",
				"submitButton": "Envoyer",
				"feedbackMessage": "Merci pour votre retour, cela nous aide beaucoup à vous proposer des articles plus pertinents à l'avenir."
			},
			"relatedContent": {
				"title": "Contenu semblable"
			},
			"search": {
				"buttonLabel": "Rechercher",
				"input": "Rechercher des articles...",
				"loading": "Téléchargement en cours...",
				"results": {
					"contact": "Vous ne trouvez pas l'aide dont vous avez besoin ?",
					"empty": "Désolés, votre recherche n'a donné aucun résultat. Essayez de rechercher un terme différent.",
					"singleTopicFound": "Nous avons trouvé un sujet",
					"multipleTopicsFound": "Nous avons trouvé {count} sujets",
					"singleArticleFound": "Nous avons trouvé un article",
					"multipleArticlesFound": "Nous avons trouvé {count} articles"
				}
			},
			"contact": {
				"title": "Contactez-nous",
				"channelsIntro": "Contactez-nous pour obtenir de l'aide.",
				"businessDetailsTitle": "Vos informations commerciales",
				"businessDetailsName": "Nom de société",
				"businessDetailsEmail": "Adresse électronique",
				"businessDetailsMid": "ID de marchand",
				"phone": {
					"title": "Appelez-nous",
					"paragraph": "Vous pouvez nous appeler les jours ouvrables durant nos heures d'ouverture. Si vous vous trouvez en Suède ou au Royaume-Uni, vous pouvez également nous appeler le week-end entre 10 h et 16 h."
				},
				"chat": {
					"title": "Chattez avec nous",
					"paragraph": "C'est le moyen le plus facile et le plus rapide de contacter notre service d'assistance. Notre chat est actuellement actif.",
					"button": "Ouvrir le chat"
				},
				"email": {
					"title": "Contactez-nous par e-mail",
					"paragraph": "Envoyez-nous un e-mail et nous vous répondrons dès que possible."
				}
			},
			"errorBoundary": {
				"title": "Une erreur s'est produite",
				"message": "Toutes nos excuses, une erreur est survenue. Vous pouvez cliquer sur le bouton ci-dessous pour réinitialiser et fermer cette barre latérale.",
				"resetButton": "Réinitialiser",
				"errorId": "ID d'erreur : {errorId}"
			},
			"tour": {
				"prev": "Précedent",
				"next": "Suivant",
				"done": "Terminé"
			},
			"notAvailableMobile": {
				"title": "Non disponible",
				"buttonBack": "Retour",
				"paragraph": "Ce contenu n'est pas disponible sur votre appareil. Essayez de l'ouvrir sur un appareil avec un écran plus grand, comme un ordinateur de bureau."
			},
			"shareButton": {
				"title": {
					"article": "Établir un lien profond avec cet article",
					"topic": "Établir un lien profond avec ce sujet",
					"tour": "Établir un lien profond avec ce voyage"
				},
				"radioItemHome": "Accueil de l'application",
				"descriptionHome": "Ouvre un article d'aide sur la page d'accueil du portail des marchands",
				"radioItemCurrent": "Page en cours",
				"descriptionCurrent": "Ouvre un article d'aide sur la page en cours"
			}
		},
		"orientation": {
			"title": "Apprendre comment ..."
		},
		"core": {
			"alert": {
				"message": "Une erreur s'est produite ! Veuillez réessayer.",
				"correlationIdLabel": "ID de corrélation :"
			},
			"header": {
				"title": "Portail des marchands"
			},
			"usermenu": {
				"language": "Langue",
				"country": "Pays",
				"timezone": "Fuseau horaire",
				"logout": "Se déconnecter",
				"profile": "Profil",
				"changeProfile": "Modifier",
				"tooltip": "Votre profil"
			},
			"appsmenu": {
				"defaultTooltip": "Vos applications",
				"initialTooltip": "Retrouvez vos applications ici.",
				"newAppsTooltip": "Nous avons de nouvelles applications à vous présenter !"
			},
			"helpful-question-mark": {
				"helpLabel": "Aide"
			},
			"languages": {
				"da": "Danois",
				"de": "Allemand",
				"en": "Anglais",
				"en_GB": "Anglais (GB)",
				"en_US": "Anglais (US)",
				"es": "Espagnol",
				"fi": "Finnois",
				"fr": "Français",
				"it": "Italien",
				"nl": "Néerlandais",
				"no": "Norvégien",
				"sv": "Suédois"
			},
			"countries": {
				"de": "Allemagne",
				"dk": "Danemark",
				"fi": "Finlande",
				"gb": "Grande-Bretagne",
				"nl": "Pays-Bas",
				"no": "Norvège",
				"se": "Suède",
				"us": "États-Unis"
			},
			"selectLanguage": {
				"title": "Sélectionnez votre langue",
				"paragraph": "Il s'agira de votre langue par défaut",
				"submit": "OK"
			},
			"selectCountry": {
				"title": "Sélectionnez votre pays",
				"paragraph": "Il s'agira de votre pays par défaut.",
				"submit": "OK"
			},
			"updateProfile": {
				"title": "Actualiser les informations",
				"submit": "OK",
				"emailLabel": "Adresse électronique",
				"firstNameLabel": "Prénom",
				"lastNameLabel": "Nom",
				"resetPasswordLabel": "Réinitialiser le mot de passe",
				"resetPasswordSuccessLabel": "E-mail de réinitialisation du mot de passe envoyé",
				"resetPasswordErrorLabel": "Erreur lors de l'envoi de l'e-mail de réinitialisation du mot de passe",
				"error": "La mise à jour des informations a échoué"
			},
			"footer": {
				"copyright": {
					"eu": "Copyright © 2005-{currentYear} Klarna Bank AB (publ). Tous droits réservés",
					"oc": "Copyright © 2005-{currentYear} Klarna Australia Pty Ltd, ABN # 82 635 912 579",
					"us": "Copyright © 2005-{currentYear} Klarna Inc. NMLS #1353190, 629 N. High Street, 3e étage, Columbus, OH 43215"
				},
				"terms": "Conditions générales"
			},
			"accessDenied": {
				"title": "Vous avez besoin d'une autorisation d'accès supplémentaire pour cette page.",
				"message": "Contactez votre administrateur ou Klarna pour toute question."
			},
			"midSelector": {
				"label": "Boutique"
			},
			"storeSelector": {
				"label": "Boutique"
			},
			"storesSelector": {
				"closeText": "Terminé",
				"closeTextWithSelection": "Appliquer la/les # sélection(s)",
				"deselectAllOptionText": "Effacer la sélection",
				"emptyStateText": "Aucune boutique trouvée",
				"label": "Boutiques",
				"searchFieldLabel": "Rechercher par boutique",
				"selectAllOptionText": "Sélectionner toutes les boutiques",
				"selectedAllText": "Toutes les boutiques",
				"selectedText": "# boutiques"
			},
			"pagination": {
				"ofLabel": "sur",
				"noResultsLabel": "Aucun résultat"
			},
			"dateRangePicker": {
				"startLabel": "Date de début",
				"endLabel": "Date de fin",
				"months": {
					"january": "Janvier",
					"february": "Février",
					"march": "Mars",
					"april": "Avril",
					"may": "Mai",
					"june": "Juin",
					"july": "Juillet",
					"august": "Août",
					"september": "Septembre",
					"october": "Octobre",
					"november": "Novembre",
					"december": "Décembre"
				},
				"weekDaysShort": {
					"monday": "L",
					"tuesday": "M",
					"wednesday": "M",
					"thursday": "J",
					"friday": "V",
					"saturday": "S",
					"sunday": "D"
				}
			},
			"appIcon": {
				"newLabel": "NOUVEAU"
			},
			"appCategory": {
				"dayToDay": "À utiliser au quotidien",
				"nko": "Klarna en ligne",
				"tools": "Outils",
				"preferences": "Préférences"
			},
			"apps": {
				"home-fe": {
					"title": "Accueil"
				},
				"nko-app": {
					"title": "Applications en ligne Klarna"
				},
				"orders-fe": {
					"title": "Commandes",
					"description": "Cherchez et gérez vos commandes passées avec Klarna.",
					"nkoLinkText": "Accéder aux commandes précédentes"
				},
				"nko-orders": {
					"title": "Commandes (KO)",
					"description": "Cherchez et gérez vos commandes passées avec Klarna En ligne."
				},
				"settlements-fe": {
					"title": "Règlements",
					"description": "Consultez vos transactions et générez des rapports pour effectuer vos rapprochements.",
					"nkoLinkText": "Accéder aux anciens rapports"
				},
				"nko-settlements": {
					"title": "Règlements (KO)",
					"description": "Trouvez les rapports sur les commandes et les paiements effectués avec Klarna En ligne."
				},
				"logs-app-fe": {
					"title": "Journaux",
					"description": "Utilisez les journaux de l'API pour résoudre les problèmes d'intégration."
				},
				"users-fe": {
					"title": "Utilisateurs",
					"description": "Invitez de nouveaux utilisateurs et gérez les utilisateurs existants sur le Portail."
				},
				"settings-fe": {
					"title": "Paramètres",
					"description": "Demandez vos identifiants d'API Klarna et gérez les paramètres de votre boutique."
				},
				"nko-settings": {
					"title": "Paramètres (KO)",
					"description": "Gérez les paramètres, rapports et coordonnées de votre boutique."
				},
				"seller-fe": {
					"title": "Point of Sale",
					"description": "Créez de nouvelles commandes avec la solution en boutique de Klarna."
				},
				"products-fe": {
					"title": "Produits",
					"description": "Bénéficiez d'un coup de pouce pour profiter au maximum de Klarna."
				},
				"upstream-fe": {
					"title": "Messages intégrés",
					"description": "Vendez plus grâce à des offres de financement adaptées et personnalisées."
				},
				"lending-fe": {
					"title": "Prêt aux marchands",
					"description": "Le financement professionnel, en toute simplicité."
				},
				"branding-fe": {
					"title": "Marque",
					"description": "Contrôlez la manière dont votre marque est présentée dans Klarna."
				},
				"disputes-fe": {
					"title": "Litiges",
					"description": "Gérez vos litiges."
				},
				"logistics-fe": {
					"title": "Logistique",
					"description": "Gérez l'ensemble de votre chaîne logistique au même endroit."
				},
				"ob-transactions-fe": {
					"title": "Transactions",
					"description": "Transactions bancaires ouvertes"
				},
				"developers": {
					"title": "Développeurs"
				},
				"product-upgrade-fe": {
					"title": "Mise à jour produit"
				},
				"marketing": {
					"title": "Marketing",
					"description": "Obtenez des ressources marketing ici pour développer votre entreprise."
				},
				"business-card-fe": {
					"title": "Carte de visite",
					"description": "Prochainement"
				},
				"support": {
					"title": "Assistance",
					"description": "Vérifier et gérer vos demandes d'assistance."
				}
			},
			"ui": {
				"buttons": {
					"backButton": "Retour"
				}
			},
			"errorBoundary": {
				"contact": "Veuillez essayer de rafraîchir la page. {br}Si l'erreur persiste, contactez <supportLink>le portail des marchands</supportLink> en fournissant l'ID d'erreur {errorId}",
				"errorDescription": "ID d'erreur -  {errorId}",
				"reloadButton": "Rafraîchir",
				"title": "Malheureusement, une erreur s'est produite"
			},
			"maintenance": {
				"pageTitle": "En cours de maintenance",
				"title": "Le portail des marchands est actuellement en cours de maintenance planifiée",
				"summary": "Nous serons bientôt de retour",
				"scheduledSummary": "Nous serons de retour à {until}"
			}
		},
		"blackFriday": {
			"v1": {
				"title": "Black Friday",
				"intro": "L’une des journées de vente les plus importantes est en approche. Lors du Black Friday, nous serons disponibles pour vous fournir des statistiques en temps quasi réel de vos ventes. En attendant, préparons-nous à des ventes réussies!",
				"countdown": "Compte à rebours : #dj #hh #mm #ss…",
				"box1": {
					"title": "Des dépenses 3,5 fois plus élevées*",
					"text": "L’année dernière, les acheteurs* Klarna ont dépensé en moyenne 3,5 fois plus lors du Black Friday que lors de toute autre journée de l’année.",
					"footnote": "* Moyenne réalisée sur l’ensemble des catégories et des régions des marchands Klarna."
				},
				"box2": {
					"title": "Volume de ventes 2,5 fois plus élevé*",
					"text": "L’année dernière, les marchands Klarna ont généré 2,5 fois plus de volume de ventes lors du Black Friday que lors de toute autre journée de l’année.",
					"footnote": "* Moyenne réalisée sur l’ensemble des catégories et des régions des marchands Klarna."
				},
				"sectionTitle": "Stimulez vos ventes lors du Black Friday",
				"marketing": {
					"title": "Faites promouvoir votre entreprise avant et pendant le Black Friday",
					"text": "Attirez davantage d’acheteurs dans votre boutique au cours de la saison de vente du Black Friday avec ces ressources libres d’utilisation pour les réseaux sociaux et les campagnes e-mail."
				},
				"branding": {
					"title": "Démarquez-vous dans l’application Klarna",
					"text": "12 millions d’acheteurs utilisent l’application Klarna tous les mois. Assurez-vous de vous démarquer dans l’application au cours de ce Black Friday en ajoutant et en mettant à jour vos informations de marque dans le Portail marchand."
				},
				"cta": "C’est parti",
				"close": "Fermer"
			},
			"v2": {
				"title": "Black Friday week",
				"orderVolume": "Volume des commandes",
				"orderCountTitle": "Commandes créées",
				"orderCount": "{count} commandes",
				"box": {
					"title": "Vous souhaitez augmenter votre taux de conversion?",
					"subtitle1": "Messages intégrés",
					"subtitle2": "Des messages promotionnels qui instruisent.",
					"text": "Notre outil Messages intégrés vous aide à accroître vos ventes et la valeur moyenne des commandes grâce à des messages promotionnels. Indiquez à vos clients les différentes options de paiement dont ils disposent lors de leur arrivée sur votre site et tout au long de leur navigation.",
					"cta": "C’est parti"
				},
				"selector": {
					"done": "Terminé",
					"applySelection": "Appliquer la/les # sélection(s)",
					"selectAll": "Tout sélectionner",
					"allOptions": "Toutes les options sélectionnées",
					"someOptions": "# options sélectionnées",
					"storeMultiSelectLabel": "Choisir # boutiques",
					"allStores": "Toutes les boutiques"
				},
				"currencyLabel": "Choisir la devise",
				"storeLabel": "Choisir la boutique"
			},
			"v3": {
				"title": "Black Friday week",
				"text": "Voici vos ventes réalisées pendant l'une des semaines les plus importantes de l'année.",
				"summaryTitle": "Synthèse",
				"orderVolume": "Volume total",
				"orderCount": "Total des commandes",
				"summaryRange": "23-30 November",
				"comparisonLastWeek": "par rapport au même jour, la semaine dernière",
				"tabs": {
					"monday": "Lundi",
					"tuesday": "Mardi",
					"wednesday": "Mercredi",
					"thursday": "Jeudi",
					"blackFriday": "Black Friday",
					"saturday": "Samedi",
					"sunday": "Dimanche",
					"cyberMonday": "Cyber Monday"
				}
			}
		}
	}
};